import { useEffect, useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './api';
import { LoginPage } from './components/LoginPage';
import { Dashboard } from './components/Dashboard';

export function App() {
  const queryClient = useQueryClient();
  const [offline, setOffline] = useState(() => !navigator.onLine);
  const [updateReady, setUpdateReady] = useState(false);
  const session = useQuery({ queryKey: ['session'], queryFn: api.session, retry: false, staleTime: 60_000 });

  useEffect(() => {
    const online = () => setOffline(false);
    const offlineHandler = () => setOffline(true);
    const update = () => setUpdateReady(true);
    window.addEventListener('online', online);
    window.addEventListener('offline', offlineHandler);
    window.addEventListener('sprout:update-ready', update);
    return () => {
      window.removeEventListener('online', online);
      window.removeEventListener('offline', offlineHandler);
      window.removeEventListener('sprout:update-ready', update);
    };
  }, []);

  function handleLogin() {
    void queryClient.invalidateQueries({ queryKey: ['session'] });
  }

  function handleUpdate() {
    window.location.reload();
  }

  if (session.isPending) {
    return (
      <main className="session-splash" aria-busy="true" aria-label="Restoring your session">
        <span className="brand-mark" aria-hidden="true">S</span>
        <div className="spinner" />
        <p>Opening the potting shed…</p>
      </main>
    );
  }

  if (!session.data) {
    return <LoginPage onLogin={handleLogin} restoreError={session.isError} offline={offline} />;
  }

  return (
    <>
      <Dashboard user={session.data} offline={offline} />
      {updateReady && (
        <aside className="update-toast" role="status">
          <span>A fresh version is ready.</span>
          <button type="button" onClick={handleUpdate}>Update now</button>
        </aside>
      )}
    </>
  );
}
